import { Box, Text, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

export const Title = Text.withConfig({
  fontSize: 'lg',
  color: primitive.$white,
  fontWeight: 'bold',
});

export const RetakeText = Text.withConfig({
  fontSize: 12,
  color: primitive.$white,
  fontWeight: 'bold',
  justifyContent: 'center',
});

export const CustomButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: false,
  letterSpacing: '0.5px',
  padding: '$1',
  paddingX: '$3',
  backgroundColor: primitive.$black,
  _text: {
    fontSize: 12,
    color: primitive.$white,
  },
});

export const SubmitYourPhotoButton = makeUclComponent(ActionButton).withConfig({
  width: 300,
  margin: 'auto',
  bottom: 3,
});

export const RetakeButton = CustomButton.withConfig({
  borderColor: primitive.$white,
  borderWidth: '2px',
  height: 30,
});

export const TopBar = Box.withConfig({
  left: 0,
  right: 0,
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: primitive.$black,
  zIndex: 10,
  width: '100%',
  paddingX: 2,
});
